import requiredPermissions from './requiredPermissions';
const { INTERNAL, BROWSE_COMPLETED_VIDEOS_INTERNAL } = requiredPermissions;

export const topNavLinks = [
  {
    label: 'Traffic',
    url: '/traffic',
    icon: 'trafficV2',
    requiredPermission: INTERNAL
  },
  {
    label: 'Clients',
    url: '/internal/organisations',
    icon: 'clientsV2',
    requiredPermission: INTERNAL
  },
  {
    label: 'Reports',
    url: '/internal/reporting',
    icon: 'reportsV2',
    requiredPermission: INTERNAL
  },
  {
    label: 'Library',
    url: '/internal/all-projects',
    icon: 'libraryV2',
    requiredPermission: BROWSE_COMPLETED_VIDEOS_INTERNAL
  },
  {
    label: 'System',
    url: '/system-asset-library/pro',
    icon: 'systemV2',
    requiredPermission: INTERNAL
  }
] as const;
